export default "/static/dashboard/build/app/img/v2/3bfafc4d8cda32dee4976d112b42a68f.png";